export class CalculateBulkLicenseRenewalFeeAPIError extends Error {
  constructor(message) {
    super(message);
    this.name = 'CalculateBulkLicenseRenewalFeeAPIError';
  }
}
